module.exports = __webpack_public_path__ + "static/img/14.22ccefd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/14.png
// module id = 0iJ9
// module chunks = 0